import React from "react";
import { money } from "./staffpage";

function span(from, through) {
  if (from && through) return from + " – " + through;
  return from || through || "—";
}

export default function ReservationPayments({ payments }) {
  if (!payments || payments.ready === false) {
    return <p className="staff-note">Payments did not load.</p>;
  }
  const rows = payments.rows || [];
  if (!rows.length) {
    return (
      <p className="pay-empty">
        No new-app charges on this reservation. History still has every version of the contract.
      </p>
    );
  }
  return (
    <div className="pay-wrap">
      <p className="pay-empty">Each row is a charge that went through. An unpaid quote is not listed.</p>
      <div className="pay-scroll">
        <table className="pay-table">
          <thead>
            <tr>
              <th>Paid</th>
              <th>What</th>
              <th>Rental dates</th>
              <th>Insurance dates</th>
              <th>Rental</th>
              <th>Insurance</th>
              <th>Charged</th>
              <th>Running</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.paidAt + row.runningUsd}>
                <td>{row.paidAt}</td>
                <td>{row.kind}</td>
                <td>{span(row.rentalFrom, row.rentalThrough)}</td>
                <td>{span(row.insuranceFrom, row.insuranceThrough)}</td>
                <td>{money(row.rentalUsd)}</td>
                <td>{money(row.insuranceUsd)}</td>
                <td>{money(row.chargedUsd)}</td>
                <td>{money(row.runningUsd)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
